
export class SmartchargingModel {
    name?:string;
    type?: string;
    recurrence?: string;
    
}
